import { RecentTextChip } from './RecentTextChip';
import type { RecentTextItem } from '../hooks/useRecentlyUsed';
import './RecentTextSection.css';

interface RecentTextSectionProps {
  items: RecentTextItem[];
  onSelectItem: (text: string) => void;
  onDeleteItem: (id: string) => void;
  onClearAll: () => void;
}

export function RecentTextSection({
  items,
  onSelectItem,
  onDeleteItem,
  onClearAll
}: RecentTextSectionProps) {
  const handleClearAll = () => {
    const confirmed = window.confirm('Clear all recent items?');
    if (confirmed) {
      onClearAll();
    }
  };

  if (items.length === 0) {
    return (
      <div className="recent-text-section">
        <div className="recent-text-header">
          <span className="recent-text-label">Recently Used:</span>
        </div>
        <p className="recent-text-empty">No recent items</p>
      </div>
    );
  }

  return (
    <div className="recent-text-section">
      <div className="recent-text-header">
        <span className="recent-text-label">Recently Used:</span>
        <button
          onClick={handleClearAll}
          className="recent-text-clear-all"
          aria-label="Clear all recent items"
        >
          Clear All
        </button>
      </div>
      <div className="recent-text-chips">
        {items.map(item => (
          <RecentTextChip
            key={item.id}
            text={item.text}
            onSelect={() => onSelectItem(item.text)}
            onDelete={() => onDeleteItem(item.id)}
          />
        ))}
      </div>
    </div>
  );
}
